import { PlanogramLevel } from "../models/planogram-level";

export class UpdateMerchDefaultLevelsRequest{
    merchId : number = -1;
    levels : PlanogramLevel[];
    constructor(merchId: number, levels: PlanogramLevel[]){
        this.merchId = merchId;
        this.levels = levels;
    }
}

